export const BANNER_CLICK_EVENT = 'banner_click';
export const BANNER_IMPRESSION_EVENT = 'banner_impression';
export const IMPRESSION = 'impression';
export const BUTTON_IMPRESSION = 'widget_button_impression';
export const BUTTON_CLICK = 'widget_button_clicked';
export const CLICK = 'click';
export const HAMBURGER_CLICK = 'hamburger_click';
